import QuranImage from "../../../images/approach/quran.jpg";
import LibraryImage from "../../../images/approach/library.jpg";
import DecorationImage from "../../../images/lantern.png";
import en from "../../../locales/en";
import IsPresent from "../../../components/IsPresent";
import useVisible from "../../../hooks/useVisibility";

export default function FreeCoursesSection() {
  const data = en["approach-page"]["free-courses-section"];
  const [ref, isVisible] = useVisible();

  return (
    <div className="relative" ref={ref}>
      <div className="absolute inset-0 bg-white/90 z-0" />
      <img src={DecorationImage} alt="Decoration" className="mv-decoration z-10 lg:flex hidden" />
      <img src={QuranImage} className="inset-0 size-full -z-10 absolute object-cover" />

      {/** CONTENT */}
      <div className="px-4 py-10 md:py-20 container mx-auto max-w-screen-2xl relative z-10 text-center flex flex-col gap-8 items-center">
        <div className="white-bg-heading">{data.heading}</div>
        <div className="white-bg-desc max-w-screen-xl">{data.description}</div>

        <div className="flex justify-center gap-8 w-full items-center flex-col md:flex-row">
          <img className="rounded-lg md:w-1/2 hidden md:flex" src={LibraryImage} />
          <div className={`flex flex-col gap-4 md:w-1/3 ${isVisible && "animate-fade-in"}`}>
            <>
              {data.courses.map((course, index) => {
                return (
                  <div
                    key={index}
                    className="bg-white rounded-lg border border-accent-color p-4 flex flex-col items-center shadow-sm cursor-pointer relative group overflow-hidden"
                  >
                    <div className="flex flex-col relative z-10">
                      <div className="text-lg font-semibold text-accent-color group-hover:text-white">{course.heading}</div>
                      <IsPresent data={course.subHeading}>
                        <div className="text-gray-600 text-sm group-hover:text-white/70">{course.subHeading}</div>
                      </IsPresent>
                    </div>

                    <div className="group-hover:translate-x-0 -translate-x-full transition-transform bg-accent-gradient opacity-100 absolute inset-0" />
                  </div>
                );
              })}
            </>
          </div>
        </div>
      </div>
    </div>
  );
}
